var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "flex",
    {
      staticClass: "main-head",
      attrs: { align: "center", justify: "between" }
    },
    [
      _c(
        "flex",
        {
          staticClass: "head-img",
          attrs: { align: "center" },
          on: { click: _vm.toHome }
        },
        [
          _c("img", { attrs: { src: require("@/static/img/logo.png") } }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.dataBase))])
        ]
      ),
      _vm._v(" "),
      _c(
        "flex",
        [
          _c(
            "flex",
            {
              staticClass: "base-button open",
              attrs: { align: "center", justify: "center" },
              on: { click: _vm.toOpenPlatform }
            },
            [
              _c("img", {
                attrs: { src: require("@/static/img/application.png") }
              }),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "10px" } }, [
                _vm._v("开放平台")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "flex",
            {
              staticStyle: { "margin-left": "30px" },
              attrs: { align: "center" }
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.realname))]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "danger", size: "small", round: "" },
                  nativeOn: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.loginOutSys()
                    }
                  }
                },
                [_vm._v("退出登录")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }